import React from 'react';
import PropTypes from 'prop-types';

const If = ({ condition, children }) => {
    if (!condition) {
        return null;
    }

    return React.createElement(React.Fragment, null, children);
};

If.propTypes = {
    condition: PropTypes.bool.isRequired,
    children: PropTypes.node.isRequired,
};

export default If;
